import React, { useEffect, useState } from "react";
import loaderGif from "../../../../../../assets/images/loader.gif";
import { Tooltip } from "react-tooltip";
import "../Reach.css";

const ReachList = ({
  tableData,
  getReach,
  updateStatus,
  search,
  loader,
  sortingColumn,
  sortingOrder,
  onSort,
  deleteReach
}) => {
  const reachListData = (id) => {
    getReach(id);
  };

  return (
    <>
      <div className="table-responsive custom-table">
        <table className="table table-striped">
          <thead>
            <tr>
              <th className="srno">Sr. No.</th>
              <th className="partner" onClick={() => onSort("geo_name")}>
                Geo{" "}
                {sortingColumn === "geo_name" ? (
                  <i
                    className={`fas fa-sort-${
                      sortingOrder === "asc" ? "up" : "down"
                    }`}
                  ></i>
                ) : (
                  <i className="fas fa-sort"></i>
                )}
              </th>
              <th className="partner" onClick={() => onSort("segment_name")}>
                Segment{" "}
                {sortingColumn === "segment_name" ? (
                  <i
                    className={`fas fa-sort-${
                      sortingOrder === "asc" ? "up" : "down"
                    }`}
                  ></i>
                ) : (
                  <i className="fas fa-sort"></i>
                )}
              </th>

              <th className="margin" onClick={() => onSort("reach")}>
                Reach{" "}
                {sortingColumn === "reach" ? (
                  <i
                    className={`fas fa-sort-${
                      sortingOrder === "asc" ? "up" : "down"
                    }`}
                  ></i>
                ) : (
                  <i className="fas fa-sort"></i>
                )}
              </th>

              <th className="margin" onClick={() => onSort("desktop")}>
                Desktop{" "}
                {sortingColumn === "desktop" ? (
                  <i
                    className={`fas fa-sort-${
                      sortingOrder === "asc" ? "up" : "down"
                    }`}
                  ></i>
                ) : (
                  <i className="fas fa-sort"></i>
                )}
              </th>

              <th className="margin" onClick={() => onSort("mobile")}>
                Mobile{" "}
                {sortingColumn === "mobile" ? (
                  <i
                    className={`fas fa-sort-${
                      sortingOrder === "asc" ? "up" : "down"
                    }`}
                  ></i>
                ) : (
                  <i className="fas fa-sort"></i>
                )}
              </th>

              <th className="margin" onClick={() => onSort("smartTV")}>
                SmartTV{" "}
                {sortingColumn === "smartTV" ? (
                  <i
                    className={`fas fa-sort-${
                      sortingOrder === "asc" ? "up" : "down"
                    }`}
                  ></i>
                ) : (
                  <i className="fas fa-sort"></i>
                )}
              </th>

              <th className="margin" onClick={() => onSort("banner")}>
                Banner{" "}
                {sortingColumn === "banner" ? (
                  <i
                    className={`fas fa-sort-${
                      sortingOrder === "asc" ? "up" : "down"
                    }`}
                  ></i>
                ) : (
                  <i className="fas fa-sort"></i>
                )}
              </th>

              <th className="margin" onClick={() => onSort("video")}>
                Video{" "}
                {sortingColumn === "video" ? (
                  <i
                    className={`fas fa-sort-${
                      sortingOrder === "asc" ? "up" : "down"
                    }`}
                  ></i>
                ) : (
                  <i className="fas fa-sort"></i>
                )}
              </th>

              <th className="margin" onClick={() => onSort("metro")}>
                Metro{" "}
                {sortingColumn === "metro" ? (
                  <i
                    className={`fas fa-sort-${
                      sortingOrder === "asc" ? "up" : "down"
                    }`}
                  ></i>
                ) : (
                  <i className="fas fa-sort"></i>
                )}
              </th>

              <th className="margin" onClick={() => onSort("non_metro")}>
                Non-Metro{" "}
                {sortingColumn === "non_metro" ? (
                  <i
                    className={`fas fa-sort-${
                      sortingOrder === "asc" ? "up" : "down"
                    }`}
                  ></i>
                ) : (
                  <i className="fas fa-sort"></i>
                )}
              </th>

              <th className="margin" onClick={() => onSort("male")}>
                Male{" "}
                {sortingColumn === "male" ? (
                  <i
                    className={`fas fa-sort-${
                      sortingOrder === "asc" ? "up" : "down"
                    }`}
                  ></i>
                ) : (
                  <i className="fas fa-sort"></i>
                )}
              </th>

              <th className="margin" onClick={() => onSort("female")}>
                Female{" "}
                {sortingColumn === "female" ? (
                  <i
                    className={`fas fa-sort-${
                      sortingOrder === "asc" ? "up" : "down"
                    }`}
                  ></i>
                ) : (
                  <i className="fas fa-sort"></i>
                )}
              </th>

              <th className="action">Action</th>
            </tr>
          </thead>

          {!loader ? (
            <tbody>
              {tableData && tableData.length > 0 ? (
                tableData?.map((item, i) => (
                  <React.Fragment key={i}>
                    <tr>
                      <td className="srno">{i + 1}</td>
                      <td className="partner">{item?.geo_name}</td>
                      <td className="partner">{item?.segment_name}</td>
                      <td className="margin">{item?.reach}</td>
                      <td className="margin">{item?.desktop} </td>
                      <td className="margin">{item?.mobile} </td>
                      <td className="margin"> {item?.smartTV} </td>
                      <td className="margin">{item?.banner} </td>
                      <td className="margin">{item?.video} </td>
                      <td className="margin">{item?.metro} </td>
                      <td className="margin">{item?.non_metro} </td>
                      <td className="margin">{item?.male} </td>
                      <td className="margin">{item?.female} </td>

                      <td className="text-center status">
                        <div className="table-icons">
                          <i
                            className="fa-regular fa-pen-to-square green"
                            onClick={() => reachListData(item?.id)}
                          ></i>
                          <i
                            className="fa-regular fa-trash-can red ms-2"
                            onClick={() => deleteReach(item?.id)}
                            style={{ cursor: "pointer" }}
                          ></i>
                        </div>
                      </td>
                    </tr>
                  </React.Fragment>
                ))
              ) : (
                <tr>
                  <td colSpan="9" className="text-center">
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          ) : (
            <div className={`loader ${loader ? "show" : ""}`}>
              <label>
                <img src={loaderGif} alt="Loading..." />
              </label>
            </div>
          )}
        </table>
      </div>

      <Tooltip id="my-tooltip-inline" place="top" className="custom-tooltip" />
    </>
  );
};

export default ReachList;
